import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/career-personality-quiz/CareerQuizContent.tsx");
